import { MiscTopic } from './misc-topic';

// fancy way of combining enums - export both the const and the type with the same name.
export const Topic = {
    ...MiscTopic,
};
export type Topic =
    MiscTopic;
